import Vue from 'vue/dist/vue.js'
import checkView from 'vue-check-view'
import fetchWrapper from "../modules/fetchWrapper";
Vue.use(checkView)

// new Vue({
// 	el: "#v-search",
// 	data(){
// 		return {
// 			roomsAmountList: [
// 				{ label: "2 pokoje", value: "2" },
// 				{ label: "3 pokoje", value: "3" },
// 				{ label: "4 pokoje", value: "4" },
// 			],
// 			selectedRoomsAmount: 0,
// 			areaList: [
// 				{ label: "40 - 50 m<sup>2</sup>", value: "40,50" },
// 				{ label: "50 - 60 m<sup>2</sup>", value: "50,60" },
// 				{ label: "60 - 70 m<sup>2</sup>", value: "60,70" },
// 			],
// 			selectedArea: 0,
// 			isModalVisible: false,
// 			isContactFormVisible: false,
// 			isLoading: false,
// 			buildings: [],
// 		}
// 	},
// 	methods: {
// 		async submit(e) {
// 			e.preventDefault();
// 			this.isLoading = true;

// 			const wrapper = document.querySelector('#v-search-form');

// 			const queryString = new URLSearchParams({
// 				rooms: this.roomsAmountList[this.selectedRoomsAmount].value,
// 				area: this.areaList[this.selectedArea].value,
// 				// tier: wrapper.getAttribute('data-tier'),
// 				// block: wrapper.getAttribute('data-block')
// 			}).toString();

// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php?action=search_apartments&${queryString}`,
// 				method: "GET",
// 			});

// 			this.isLoading = false;

// 			if(status >= 300){

// 			}else{
// 				document.body.classList.add('overflow-hidden')
// 				this.isModalVisible = true;
// 				this.buildings = result.data
// 			}
// 		},
// 		hideModal(){
// 			document.body.classList.remove('overflow-hidden')
// 			this.isModalVisible = false;
// 		},
// 		showContactForm(v){
// 			this.isContactFormVisible = true;
// 			document.querySelector('#v-search-form').querySelector('[name="subject"]').value = v
// 			document.querySelector('#v-search-form').querySelector('[name="message"]').value = `Jestem zainteresowany/a "${v}". Proszę o kontakt w celu omówienia szczegółów.`
// 		}
// 	}
// })


// new Vue({
// 	el: "#v-flats",
// 	data(){
// 		return {
// 			category: "sell",
// 			total: 0,
// 			sortSelected: "",
// 			type: "",
// 			rooms: "",
// 			area: "",
// 			tier: "",
// 			city: "",
// 			pricePerMeter: "",
// 			isLoading: false,
// 			isLoading2: false,
// 			flats: [],
// 			pagination: {
// 				baseUrl: '/mieszkania',
// 				perPage: 1,
// 				currentPage: 1,
// 				totalPages: 3,
// 				hasPreviousPage: false,
// 				hasNextPage: true,
// 				scrollTo: '#form'
// 			}
// 		}
// 	},
// 	methods: {
// 		async submit(e) {
// 			if(e){
// 				e.preventDefault();
// 			}

// 			this.isLoading = true;
// 			console.log(this.area)

// 			const queryString = new URLSearchParams({
// 				limit: 10,
// 				type: this.type,
// 				category: this.category,
// 				sort: this.sortSelected,
// 				rooms: this.rooms,
// 				area: this.area,
// 				tier: this.tier,
// 				city: this.city,
// 				pricePerMeter: this.pricePerMeter
// 			}).toString();

// 			window.history.pushState({}, null, window.location.href.split('?')[0] + '?' + queryString)

// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php?action=search_flats&${queryString}`,
// 				method: "GET",
// 			});

// 			console.log(queryString)
// 			console.log(status, result);

// 			this.isLoading = false;

// 			if(status >= 300){

// 			}else{
// 				this.isModalVisible = true;
// 				this.flats = result.data
// 				this.total = result.total
// 			}
// 		},
// 		async addRemoveObserve(id){
// 			this.isLoading2 = true;

// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php`,
// 				method: "POST",
// 				body: {
// 					action: 'add_remove_observed',
// 					id
// 				}
// 			});

// 			this.isLoading2 = false;


// 			// this.signupIsLoading = false;
// 			// this.signupMessage = result.body.message
// 			console.log(status, result)

// 			if(status >= 300){
// 				// failed
// 			}else{
// 				const item = document.getElementById(`${id}`);
// 				const addToObserveBtn = item.querySelector('.js-add-to-observe');
// 				if(result.body.is_added){
// 					if(addToObserveBtn){
// 						addToObserveBtn.classList.add('bg-primary')
// 						addToObserveBtn.classList.remove('bg-quinary')
// 						addToObserveBtn.querySelector('svg').classList.add('text-white')
// 						addToObserveBtn.querySelector('svg').classList.remove('text-quaternary')
// 					}
// 				}else{
// 					if(addToObserveBtn){
// 						addToObserveBtn.classList.remove('bg-primary')
// 						addToObserveBtn.classList.add('bg-quinary')
// 						addToObserveBtn.querySelector('svg').classList.remove('text-white')
// 						addToObserveBtn.querySelector('svg').classList.add('text-quaternary')
// 					}
// 				}
// 				// if(item) item.remove();
// 				// window.location.reload();
// 				// this.state = 1
// 			}
// 		},
// 		showContactForm(v){
// 			this.isContactFormVisible = true;
// 			document.querySelector('#v-search-form').querySelector('[name="subject"]').value = v
// 			document.querySelector('#v-search-form').querySelector('[name="message"]').value = `Jestem zainteresowany/a "${v}". Proszę o kontakt w celu omówienia szczegółów.`
// 		}
// 	},
// 	mounted(){
// 		const wrapper = document.querySelector('#v-flats')
// 		this.type = wrapper.querySelector('[name="type"]').getAttribute('data-value')
// 		this.city = wrapper.querySelector('[name="city"]').getAttribute('data-value')
// 		this.tier = wrapper.querySelector('[name="tier"]').getAttribute('data-value')
// 		this.rooms = wrapper.querySelector('[name="rooms"]').getAttribute('data-value')
// 		this.area = wrapper.querySelector('[name="area"]').getAttribute('data-value')
// 		this.areaPerMeter = wrapper.querySelector('[name="pricePerMeter"]').getAttribute('data-value')

// 		console.log("TYPE", wrapper.querySelector('[name="type"]'))
		
// 		this.submit();
// 	}
// })




// new Vue({
// 	el: "#v-search-form",
// 	data(){
// 		return {
// 			isModalVisible: false,
// 			isContactFormVisible: false,
// 			isLoading: false,
// 			flats: [],
// 			rooms: "",
// 			area: "",
// 			tier: "",
// 			city: "",
// 		}
// 	},
// 	methods: {
// 		async submit(e) {
// 			e.preventDefault();
// 			this.isLoading = true;

// 			const queryString = new URLSearchParams({
// 				tier: this.tier,
// 				rooms: this.rooms,
// 				area: this.area,
// 				side: this.side,
// 				status: this.status
// 			}).toString();

// 			console.log(`/wp-admin/admin-ajax.php?action=search_flats_buildings&${queryString}`)
// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php?action=search_flats_buildings&${queryString}`,
// 				method: "GET",
// 			});

// 			this.isLoading = false;

// 			console.log(status, result)

// 			if(status >= 300){

// 			}else{
// 				document.body.classList.add('overflow-hidden')
// 				this.isModalVisible = true;
// 				this.flats = result.data
// 			}
// 		},
// 		hideModal(){
// 			document.body.classList.remove('overflow-hidden')
// 			this.isModalVisible = false;
// 		},
// 		showContactForm(v){
// 			this.isContactFormVisible = true;
// 			document.querySelector('#v-search-form').querySelector('[name="subject"]').value = v
// 			document.querySelector('#v-search-form').querySelector('[name="message"]').value = `Jestem zainteresowany/a "${v}". Proszę o kontakt w celu omówienia szczegółów.`
// 		}
// 	},
// 	mounted(){
// 		const wrapper = document.querySelector('#v-search-form')
// 		this.tier = wrapper.querySelector('[name="tier"]').getAttribute('data-value')
// 		this.rooms = wrapper.querySelector('[name="rooms"]').getAttribute('data-value')
// 		this.area = wrapper.querySelector('[name="area"]').getAttribute('data-value')
// 		this.side = wrapper.querySelector('[name="side"]').getAttribute('data-value')
// 		this.status = wrapper.querySelector('[name="status"]').getAttribute('data-value')
// 	}
// })




// new Vue({
// 	el: "#v-flat-table",
// 	data(){
// 		return {
// 			isLoading: false,
// 			flats: [],
// 			building: '',
// 			tier: '',
// 		}
// 	},
// 	methods: {
// 		async submit(e) {
// 			this.isLoading = true;

// 			const queryString = new URLSearchParams({
// 				building: this.building,
// 				tier: this.tier,
// 			}).toString();

// 			console.log(`/wp-admin/admin-ajax.php?action=search_flats_buildings&${queryString}`)
// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php?action=search_flats_buildings&${queryString}`,
// 				method: "GET",
// 			});

// 			this.isLoading = false;

// 			console.log(status, result)

// 			if(status >= 300){

// 			}else{
// 				this.isModalVisible = true;
// 				this.flats = result.data
// 			}
// 		},
// 		hideModal(){
// 			this.isModalVisible = false;
// 		},
// 		showContactForm(v){
// 			this.isContactFormVisible = true;
// 			document.querySelector('#v-search-form').querySelector('[name="subject"]').value = v
// 			document.querySelector('#v-search-form').querySelector('[name="message"]').value = `Jestem zainteresowany/a "${v}". Proszę o kontakt w celu omówienia szczegółów.`
// 		},
// 		onHashChange() {
// 			const hash = location.hash;
// 			const hashNumber = hash.replace( /^\D+/g, '')
// 			if(hash.includes('b')){
// 				this.building = hashNumber
// 			}else if(hash.includes('p')){
// 				this.tier = hashNumber;
// 			}else{
// 				this.building = '';
// 				this.tier = '';
// 			}
// 			this.submit();
// 		}
// 	},
// 	mounted(){
// 		// const wrapper = document.querySelector('#v-search-form')
// 		// this.tier = wrapper.querySelector('[name="tier"]').getAttribute('data-value')
// 		// this.rooms = wrapper.querySelector('[name="rooms"]').getAttribute('data-value')
// 		// this.area = wrapper.querySelector('[name="area"]').getAttribute('data-value')
// 		// this.areaPerMeter = wrapper.querySelector('[name="pricePerMeter"]').getAttribute('data-value')
// 		// this.garden = wrapper.querySelector('[name="garden"]').getAttribute('data-value')
// 		window.addEventListener('hashchange', () => {
// 			this.onHashChange()
// 		})
// 		this.submit();
// 	},
// })


// window.addToObserve = async (id) => {
// 	const [status, result] = await fetchWrapper({
// 		url: `/wp-admin/admin-ajax.php`,
// 		method: "POST",
// 		body: {
// 			action: 'add_observed',
// 			id
// 		}
// 	});

// 	// this.signupIsLoading = false;
// 	// this.signupMessage = result.body.message

// 	if(status >= 300){
// 		// failed
// 	}else{
// 		const item = document.getElementById(`${id}`);
// 		const addToObserveBtn = item.querySelector('.js-add-to-observe');
// 		if(addToObserveBtn){
// 			addToObserveBtn.classList.add('bg-primary')
// 			addToObserveBtn.classList.remove('bg-quinary')
// 			addToObserveBtn.querySelector('svg').classList.add('text-white')
// 			addToObserveBtn.querySelector('svg').classList.remove('text-quaternary')
// 		}
// 	}
// }





// new Vue({
// 	el: "#v-flat-table",
// 	data(){
// 		return {
// 			isLoading: false,
// 			flats: [],
// 			building: '',
// 			tier: '',
// 		}
// 	},



/* -------------------------------------------------------------------------- */
/*                               User Dashboard                               */
/* -------------------------------------------------------------------------- */
// new Vue({
// 	el: "#v-user-dashboard",
// 	data(){
// 		return {
// 			state: 0,
// 			loginForm: {
// 				action: "user_login",
// 				username: 'test',
// 				password: 'test',
// 				remember: true
// 			},
// 			loginMessage: '',
// 			loginIsLoading: false,

// 			signupForm: {
// 				action: "user_signup",
// 				username: 'test',
// 				firstname: 'test',
// 				lastname: 'test',
// 				email: 'test',
// 				password: 'test'
// 			},
// 			signupMessage: '',
// 			signupIsLoading: false,

// 			tab: 0
// 		}
// 	},
// 	methods: {
// 		async submitLogin(){
// 			this.loginIsLoading = true;
// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php`,
// 				method: "POST",
// 				body: this.loginForm
// 			});

// 			this.loginIsLoading = false;
// 			this.loginMessage = result.body.message

// 			if(status >= 300){
// 				// failed
// 			}else{
// 				window.location.reload();
// 				// this.state = 1
// 			}
// 		},
// 		async submitSignup(){
// 			this.signupIsLoading = true;
// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php`,
// 				method: "POST",
// 				body: this.signupForm
// 			});

// 			this.signupIsLoading = false;
// 			this.signupMessage = result.body.message

// 			if(status >= 300){
// 				// failed
// 			}else{
// 				window.location.reload();
// 				// this.state = 1
// 			}
// 		},
// 		async removeObserved(id){
// 			// this.signupIsLoading = true;
// 			const [status, result] = await fetchWrapper({
// 				url: `/wp-admin/admin-ajax.php`,
// 				method: "POST",
// 				body: {
// 					action: 'remove_observed',
// 					id
// 				}
// 			});

// 			// this.signupIsLoading = false;
// 			// this.signupMessage = result.body.message

// 			if(status >= 300){
// 				// failed
// 			}else{
// 				const item = document.getElementById(`${id}`);
// 				if(item) item.remove();
// 				window.location.reload();
// 				// this.state = 1
// 			}
// 		}
// 	}
// })


new Vue({
	el: "#v-search",
	data(){
		return {
			phrase: "",
			inputToggled: false,
			isModalVisible: false,
			isSearchBarVisible: false,
			isLoading: false,
			items: [],
			debounce: null
		}
	},
	methods: {
		async submit(e) {
			e.preventDefault();
			if(this.phrase == ""){
				this.inputToggled = false;
				this.isModalVisible = false;
				this.items = [];
				return;
			}
			this.isLoading = true;

			const queryString = new URLSearchParams({phrase: this.phrase}).toString();

			const [status, result] = await fetchWrapper({
				url: `/wp-admin/admin-ajax.php?action=search_phrase&${queryString}`,
				method: "GET",
			});

			this.isLoading = false;

			if(status >= 300){

			}else{
				this.isModalVisible = true;
				this.items = result.data
			}
		},
		highlight(text) {
			return text.replace(new RegExp(this.phrase, "gi"), match => {
				return '<span class="font-bold">' + match + '</span>';
			});
		},
		toggleModal(){
			document.body.classList.toggle('overflow-hidden')
			this.isModalVisible = !this.isModalVisible;
			if(!this.isModalVisible){
				this.phrase = "";
				this.toggleInput();
			}
		},
		toggleInput(){
			this.inputToggled = !this.inputToggled;
			this.$nextTick(() => {
				if(!this.$refs.input) return;
				this.$refs.input.focus();
			})
		},
		debounceSearch(event) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.submit(event);
      }, 600)
    }
	}
})
